export interface NavItem {
  id: string
  activeIcon: string
  inactiveIcon: string
  path: string
}

export const HOME_NAV_ITEM: NavItem = {
  id: 'home',
  activeIcon: '/images/home-icon.png',
  inactiveIcon: '/images/home-icon.png',
  path: '/main-home',
}

export const FEED_NAV_ITEM: NavItem = {
  id: 'feed',
  activeIcon: '/images/feed-icon.png',
  inactiveIcon: '/images/feed-icon.png',
  path: '/main-ranking',
}

export const RANKING_NAV_ITEM: NavItem = {
  id: 'ranking',
  activeIcon: '/images/ranking-icon.png',
  inactiveIcon: '/images/ranking-icon.png',
  path: '/main-map',
}

export const MY_NAV_ITEM: NavItem = {
  id: 'my',
  activeIcon: '/images/my-icon.png',
  inactiveIcon: '/images/my-icon.png',
  path: '/main-my',
}

/**
 * 가운데 + — 장소 검색으로 들어간다.
 *
 * 홈 상단 검색과 같은 화면이고 동작도 같다(장소를 고르면 지도로 이동).
 * placeholder만 기록을 유도하는 문구로 바꾼다. 검색은 "닫기"로 빠져나오는
 * 임시 화면이라 탭으로 머물지 않는다.
 */
export const RECORD_NAV_ITEM: NavItem = {
  id: 'record',
  // nav-plus-icon은 다른 네비 아이콘과 캔버스 채움(102/104)·색(#4B3621)·
  // 알파를 맞춘 전용 파일이다. 저장 시트가 쓰는 bold-plus-icon은 사방 12px
  // 여백에 알파도 낮아 여기 쓰면 혼자 작고 옅어 보인다.
  activeIcon: '/images/nav-plus-icon.png',
  inactiveIcon: '/images/nav-plus-icon.png',
  path: `/search?placeholder=${encodeURIComponent('경험한 장소를 기록해보세요')}`,
}

export const NAV_ITEMS: NavItem[] = [
  HOME_NAV_ITEM,
  FEED_NAV_ITEM,
  RECORD_NAV_ITEM,
  RANKING_NAV_ITEM,
  MY_NAV_ITEM,
]
